import { render, staticRenderFns } from "./web_ide_link.vue.js?vue&type=template&id=60eed2f9&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./web_ide_link.vue?vue&type=template&id=60eed2f9&vue3"
import script from "./web_ide_link.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./web_ide_link.vue?vue&type=script&lang=js&vue3"
export * from "./web_ide_link.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./web_ide_link.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports